module.exports = __webpack_public_path__ + "static/media/Me_2.234c1afa.jpg";